import ResourcesModule from '../../../resources/resources';
import template from './settingsUserEdit.jade';
import Services from '../../../services/services';

export class AccountSettingsUserEditController {
  /* @ngInject */
  constructor(notify, $http, $state, api, currentUser, UsersResource) {

    //NOTE: the injection of UsersResource here is necessary even though the resource itself is not used.
    //Removing it causes the users resource not to be enriched with methods like hasRole()
    this.$http = $http;
    this.api = api;
    this.$state = $state;
    this.notify = notify;
    this.currentUser = currentUser;
    this.isResourceBeingPersisted = false;
    currentUser.subscribe((user) => {
      this.user = user;
      if (user) {
        this.isMfaToggled = user.isMfaToggled;
        if (this.initialUseMfa === undefined) {
          this.initialUseMfa = user.use_mfa;
        }
      }
    });
  }

  saveUser() {
    this.user.save()
        .then((user) => {
          let fullName = `${this.user.first_name} ${this.user.last_name}`;
          this.initialUseMfa = user.use_mfa;
          this.notify.updated('user', fullName);
          user.isMfaToggled = this.isMfaToggled;
          this.currentUser.onNext(user);
        })
        .catch(this.notify.apiError)
        .finally(() => {this.isResourceBeingPersisted = false});
  }

  showResetMfa() {
    return this.initialUseMfa && this.currentUser.value.hasRole(['ADMIN']);
  }

  resetMfa() {
    let user = this.user;
    this.$http.post(`${this.api.baseURL}/oauth/token/mfa/reset`, {
      username: this.user.email
    }, {
      headers: { 'Requested-From-Component': 'pepapi-frontend'},
    }).then((result) => {
      user.use_mfa = false;
      this.currentUser.onNext(user);
      this.notify.success('resetMfaSucceed');
    })
    .catch((response) => {
      this.notify.error('resetMfaFailed')
    })
  }

  save() {
    this.isResourceBeingPersisted = true;
    if (this.initialUseMfa === this.user.use_mfa) {
      this.saveUser();
    } else if (this.user.use_mfa){
      this.$http.post(`${this.api.baseURL}/oauth/token/mfa/configure`, {
        code: this.user.mfa_code
      }, {
        headers: { 'Requested-From-Component': 'pepapi-frontend'},
      }).then((result) => {
        if (!this.user.hasRole(['AGENCY'])) {
          this.saveUser();
        } else {
          let fullName = `${this.user.first_name} ${this.user.last_name}`;
          this.notify.updated('user', fullName);
        }
      })
      .catch((response) => {
        this.notify.error('logInMfaFailed')
      })
      .finally(() => {this.isResourceBeingPersisted = false});
    } else {
      this.$http.post(`${this.api.baseURL}/oauth/token/mfa/disable`, {
        code: this.user.mfa_code
      }, {
        headers: { 'Requested-From-Component': 'pepapi-frontend'},
      }).then((result) => {
        this.saveUser();
      })
      .catch((response) => {
        this.notify.error('logInMfaFailed')
      })
      .finally(() => {this.isResourceBeingPersisted = false});
    }
  }

  isDemoAccount() {
    return this.user && this.user.id && this.user.hasRole && this.user.hasRole(['DEMO']);
  }
}

export function AccountSettingsUserEditComponent() {
  return {
    template,
    controller: AccountSettingsUserEditController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
};

export default angular.module('app.components.account.settings.userEdit', [
  ResourcesModule.name,
  Services.name
])
.directive('accountSettingsUserEdit', AccountSettingsUserEditComponent);



/** WEBPACK FOOTER **
 ** ./src/components/account/settings/settingsUserEdit.js
 **/